/** 🌍 GLOBAL STANDART KOD (TÜM PROJELER İÇİN GEÇERLİDİR)
 * Tek kaynak qubepro-core; resmî sync ile dağıtılır.
 */

function normalizeSearchText(value: string): string {
  return value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/ı/g, 'i').toLowerCase();
}

/** Search the application code and the label already resolved for the active language. */
export function matchesAppsGridSearch(query: string, code: string, label: string): boolean {
  const words = normalizeSearchText(query).trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return true;
  const candidate = normalizeSearchText(`${code} ${label}`);
  return words.every((word) => candidate.includes(word));
}
